import { getCurrentInstance } from 'vue';
import { BvModal, BvToast } from 'bootstrap-vue';

export const useToast = (): BvToast | undefined => {
    const vueInstance = getCurrentInstance()?.proxy;
    return vueInstance?.$bvToast;
};

export const useModal = (): BvModal | undefined => {
    const vueInstance = getCurrentInstance()?.proxy;
    return vueInstance?.$bvModal;
};
